import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Button, Input, message } from 'antd';
import { Grid } from 'semantic-ui-react';
import { Context } from '../../defaults';
import { submitLogin } from '../../actions';

const Login = () => {
  const { dictionary, language, setToken } = useContext(Context);
  const history = useHistory();

  const onFinish = (values) => {
    message.loading({ content: `${dictionary?.Loading[language]}...`, key: 'updatable' });

    submitLogin(values)
      .then((res) => res.json())
      .then((res) => {
        if (!res.token) {
          setTimeout(() => {
            message.error({
              content: `${dictionary?.LogInError[language]}`,
              key: 'updatable',
              duration: 2,
            });
          }, 1000);
        } else {
          localStorage.setItem('token', res.token);
          setToken(res.token);
          setTimeout(() => {
            message.success({
              content: `${dictionary?.LogInSuccess[language]}`,
              key: 'updatable',
              duration: 2,
            });
            history.push('/');
          }, 1000);
        }
      });
  };

  const onFinishFailed = () => {
    message.error({
      content: `${dictionary?.ValidationError[language]}`,
      key: 'updatable',
      duration: 2,
    });
  };

  return (
    <div>
      <Grid style={{ marginTop: 50 }}>
        <Grid.Row>
          <Grid.Column width={4}></Grid.Column>
          <Grid.Column width={8}>
            <Form
              // {...layout}
              name="basic"
              initialValues={{ remember: true }}
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 10,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}>
              <Form.Item
                label={dictionary?.UserName[language]}
                name="login"
                rules={[
                  {
                    required: true,
                    message: `${dictionary?.FillTheField[language]} '${dictionary?.UserName[language]}'`,
                  },
                ]}>
                <Input />
              </Form.Item>

              <Form.Item
                label={dictionary?.Password[language]}
                name="password"
                rules={[
                  {
                    required: true,
                    message: `${dictionary?.FillTheField[language]} '${dictionary?.Password[language]}'`,
                  },
                ]}>
                <Input.Password />
              </Form.Item>

              <Form.Item label=".">
                <Button type="primary" htmlType="submit">
                  {dictionary?.LogIn[language]}
                </Button>
              </Form.Item>
            </Form>
          </Grid.Column>
          <Grid.Column width={4}></Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default Login;
